<template>
  <GekkoButton 
    @click="openPremiumCongrats"
    :text="$gettext('Open premium congrats')"
    variant="link text-blue"
    :icon="'fa-solid fa-sparkles'"
    icon-right
    class="display-none"
  />
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import GekkoButton from "@/components/GekkoButton";

export default {
  name: 'PremiumCongratsLink',
  components: { 
    GekkoButton 
  },
  props: {
    openWelcome: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({ 
      getCompanyBelongsToUser: 'main/getCompanyBelongsToUser',
    })
  },
  created () {
    if (this.$route.query.premium_congrats === 'yes' && this.getCompanyBelongsToUser) {
      this.openPremiumCongrats()
    }
  },
  methods: {
    ...mapMutations({ 
      openPremiumCongrats: 'onboarding/OPEN_PREMIUM_CONGRATS',
    }),
    
  },
}
</script>

<style lang="scss">
</style>

